import React, { useState, useEffect } from 'react';
import { ContentBox } from "../ContentBox"
import { SystemPromptInput } from '../../Res/SystemPrompt';
import 'rc-datepicker/lib/style.css';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { ReqPermissionList } from '../../../../item/ItemPermission';
import { api_getRolePermissionList } from '../../../../api/apiPermission';

export function DepartmentPositionPermissionList({ id, setIsLoading }) {
    const [roleId, setRoleId] = useState("")
    const [permissionList, setPermissionList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)

    useEffect(() => {
        if (id !== undefined && id !==roleId ) {
            setRoleId(id)
        }
    }, [id])

    useEffect(()=>{
        if(roleId !== ""){
            toSearch({ page: 1 })
        }
    },[roleId])

    // useEffect(()=>{
    //     if(Object.keys(mReqEmployeeResumeList).length !== 0){
    //         toSearch({items: mReqEmployeeResumeList})
    //     }
    // },[mReqEmployeeResumeList])

    function toSearch({ page = 1 }) {
        //console.log("toSearch")
        var start = (page - 1) * limit;
        setPage(page)
        var mReqPermissionList = new ReqPermissionList({ roleId, start, limit })
        getPermissionList(mReqPermissionList)
    }


    async function getPermissionList(mReqPermissionList) {
        setIsLoading(true)
        api_getRolePermissionList({
            mReqPermissionList,
            success: (obj) => {
                //console.log(obj)
                setPermissionList(obj.list)
                setCount(obj.count)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }

    function toAdd() {
        window.location.assign("/DepartmentPositionPermission/"+roleId);
    }


    var baseTitle = "權限列表"
    var baseContent =
        <>
            <div className="row m-b-sm">
            </div>
            <ListBox permissionList={permissionList} action={setPermissionList} count={count} page={page} sp={toSearch} />
        </>

    var title_tools =
        <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => toAdd()}>
            <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">設定</span>
        </a>

    return (
        <>
            <ContentBox title={baseTitle} title_tools={title_tools} content={baseContent} hasDrawer={false} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}


function ListBox({ permissionList, action, count, page, sp }) {
    const [mPermissionList, setPermissionList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (permissionList !== undefined && mPermissionList !== permissionList) {
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + permissionList.length)
            setPermissionList(setTableList(permissionList))
            setPage(page)
        }

    }, [permissionList])

    useEffect(() => {
        if (count !== mCount) {
            setCount(count)
        }
    }, [count])

    function setTableList(permissionList) {
        var list = []
        for (var i = 0; i < limit; i++) {
            if (permissionList[i] !== undefined) {
                list.push(<PermissionBox key={permissionList[i].permissionId} permission={permissionList[i]} />)
            } else {
                list.push(<PermissionBox key={"resumeId" + i} />)
            }
        }
        return list
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (mPermissionList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-3">頁面</th>
                                    <th className="text-center sorting col-sm-6">說明</th>
                                    <th className="text-center sorting col-sm-3">網頁名稱</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    mPermissionList.map((permission) => (
                                        permission
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function PermissionBox({ permission }) {
    const [mPermission, setPermission] = useState({})
    const [pageName, setPageName] = useState("")
    const [pageDescription, setPageDescription] = useState("")
    const [pageLink, setPageLink] = useState("")

    useEffect(() => {
        if (permission !== undefined && permission !== mPermission) {
            //console.log(department)
            setPermission(permission)
            setPageName(permission.pageName)
            setPageDescription(permission.pageDescription)
            setPageLink(permission.pageLink)
        }
    }, [permission])


    return (
        <tr role="row">
            <td className="text-center">{pageName}&nbsp;</td>
            <td className="text-center">{pageDescription}</td>
            <td className="text-center">{pageLink}</td>
        </tr>
    )
}
